import './header.scss';

import { CHeader, CHeaderNav, CSubheader, CToggler } from '@coreui/react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { routeConfig } from '../../../navigation/routeConfig';
import { Language } from '../../language/Language';
import { OnLineUsers } from '../../OnlineUsers/OnlineUsers';
import { UserProfile } from '../../UserProfile/UserProfile';
import { Breadcrumbs } from '../breadcrumbs/Breadcrumbs';

interface IHeaderProps {
  sidebarState: '' | true | false | 'responsive';
  onSidebarToggle: (show: '' | true | false | 'responsive') => void;
}

export const Header: React.FunctionComponent<IHeaderProps> = ({ sidebarState, onSidebarToggle }) => {
  const { t } = useTranslation();
  const flags = useFlags();
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const routeConfigCopy = JSON.parse(JSON.stringify(routeConfig));
  const routes = Object.keys(routeConfigCopy).map((key: any) => routeConfigCopy[key]);
  routes.map(route => route.name && (route.name = t(`routes.${route.name}`)));

  const toggleSidebar = () => {
    const state = [true, 'responsive'].includes(sidebarState) ? false : 'responsive';
    onSidebarToggle(state);
  };
  const toggleSidebarMobile = () => {
    const state = [false, 'responsive'].includes(sidebarState) ? true : 'responsive';
    onSidebarToggle(state);
  };

  const environments = ['localhost', 'staging', 'test', 'run.app'];
  const currEnvironment = environments.find(env => window.location.href.toString().match(env)?.length) || process.env.REACT_APP_ENVIRONMENT;
  const currentEnvironment = currEnvironment === 'run.app' ? 'preview' : currEnvironment;
  return (
    <CHeader className={`d-flex justify-content-between align-items-center ${isDropdownOpen ? 'header-z-index' : ''}`} >
      <div className="toggler-container">
        <CToggler
        inHeader
        className="ml-md-3 d-lg-none"
        onClick={toggleSidebarMobile}
        />
        <CToggler
        inHeader
        className="ml-3 d-md-down-none"
        onClick={toggleSidebar}
        />
        {currentEnvironment
          ? <div className={`badge rounded-pill text-bg-warning ${currentEnvironment}`}>{currentEnvironment}</div>
          : <div className="badge rounded-pill text-bg-warning live">live</div>}
      </div>
      <CHeaderNav className="px-3">
        <Language />
        <UserProfile setDropdownOpen={setDropdownOpen} />
      </CHeaderNav>
      <CSubheader className="px-3 justify-content-between">
        <Breadcrumbs />
        {flags.onlineUsers && <OnLineUsers setDropdownOpen={() => false} />}
      </CSubheader>
    </CHeader>
  );
};
